import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { cancelContentManagerMoveTo, setContentManagerExchange } from "../../../src/taskpane/redux/modules/contentManagerDirectory";
import { setFiles } from "../../../src/taskpane/redux/modules/file";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { Dismiss20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Dismiss20Regular";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";

export function useMenuItem_MoveToCancel() {
    const languageStrings = React.useContext(LanguageContext);

    const dispatch = useDispatch();

    const moveToEnabled = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.moveToEnabled);

    const menuItem_MoveToCancel = React.useMemo(() => {
        if (moveToEnabled) {
            return {
                key: "moveToCancel",
                text: `${languageStrings.Cancel}`,
                // iconProps: { iconName: "ChromeClose" },
                iconProps: {},
                onRenderIcon: () => <Dismiss20Regular className={menuItemIconStyles} />,
                onClick: () => {
                    // Full reset. The previous per-field dispatch left mode, siteUrl,
                    // sourceSiteUrl, sourceServerRelPath and both directory objects
                    // behind — the reducer ignores falsy values for those.
                    dispatch(cancelContentManagerMoveTo());
                    dispatch(setContentManagerExchange({ selectedFolderId: "", selectedFolderName: "", selectedAccount: "" }));
                    dispatch(setFiles([]));
                }
            } as IContextualMenuItem;
        }
        return null;
    }, [moveToEnabled]);

    return {
        menuItem_MoveToCancel
    }
}